import './session_tab_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ReviewQueueSessionTabView extends Monitoring.Views.SocialContents.SessionTabView
  template: JST['backbone/templates/monitoring/sessions/review_queue_session_tab']
  tagName: 'li'
  className: 'active session'

  events:
    'click .badge': 'onUpdateContentsCount'

  initialize: (@options = {}) ->
    @listenTo(Backbone, 'reviewQueueBatchConfirm', @onUpdateContentsCount)
    @dashboard = @options.dashboard
    @name = I18n.t('monitoring.review_queue_definition.title')
    @_renameTooltip(@name)
    @id = "minimize_tab"

  render: =>
    @$el.append(jQuery.parseHTML(@template({ name: @name })))
    this.$el.css('background-color', 'transparent')
    this.$el.css('margin-left', '20px')
    return this

  updateCount: (info) ->
    @$el.find('i.badge').html(info.all).show()
    popoverText = "Total: " + info.all + " - Blocked: " + info.blocked
    @$el.find('.badge-count-container i')[0].setAttribute("data-content", popoverText)
    window.load_popovers()

  rename: (newName) ->
    @$el.find('#name').text(newName)

  destroy: ->
    @dashboard.destroy()
    this.remove()
    return false

  onUpdateContentsCount: ->
    $.ajax
      url: '/monitoring/dashboard/queue_realtime_count/'
      type: 'POST'
      data:
        uuid: @dashboard.uuid
      global: false
      success: (data) =>
        @updateCount(data)
      dataType: "json"
